import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
    width: "60%",
    marginTop: 12,
    justifyContent: "space-evenly",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    alignSelf: "center",
  },

  cardsContainer: {
    justifyContent: "space-between",
    gap: 20,
  },

  contentCard: {
    /* marginBottom: 12, */
    height: 160,
    borderColor: "#666",
    borderWidth: 0.5,
    borderRadius: 8,
    borderColor: "#077A97",
    paddingHorizontal: 16,
    paddingVertical: 18,
    width: 340,
    shadowColor: "#000",
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 4,
  },

  txtContaBancaria: {
    flex: 1,
    textAlign: "left",
    color: "#000000",
    fontSize: 24,
    marginTop: 86,
    marginLeft: 100,
    fontWeight: "bold",
  },

  txtGerencieContas: {
    textAlign: "left",
    color: "#000000",
    fontSize: 18,
    fontWeight: "bold",
    marginLeft: 100,
  },

  cardTitleConta: {
    textAlign: "left",
    color: "#000000",
    fontSize: 18,
    flexDirection: "row",
    fontWeight: "bold",
    textTransform: "uppercase",
  },

  textInfo: {
    fontWeight: "bold",
    color: "#2C2C2E",
    lineHeight: 30,
  },
  textDescription: {
    fontWeight: "normal",
    textAlign: "center",
  },
  contentEdit: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  btnAdd: {
    marginTop: 20,
    alignItems: "center",
    justifyContent: "center",
    height: 160,
    borderColor: "#666",
    borderWidth: 0.5,
    borderRadius: 8,
    borderColor: "#077A97",
    paddingHorizontal: 16,
    paddingVertical: 18,
    width: 340,
    shadowColor: "#000",
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 4,
  },

  addIcon: {
    width: 90,
    height: 90,
  },

  textBtn: {
    textAlign: "center",
    marginTop: 15,
    fontWeight: "bold",
  },
  textNotFoundAccounts: {
    textAlign: "center",
    marginTop: 10,
    marginBottom: 10,
    fontWeight: "bold",
  },

  viewInfo: {
    /*  backgroundColor: "#D9D9D9", */
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 4,
    width: "80%",
    alignSelf: "center",
  },
});

export default styles;
